// Pagina download app mobile FieldCore
import QRCode from 'react-qr-code'
import { Smartphone, Download, Shield, Wifi } from 'lucide-react'

const APK_URL = `${window.location.origin}/app/fieldcore.apk`

export function MobilePage() {
  return (
    <div className="max-w-2xl mx-auto py-8 px-4 space-y-8">
      {/* Header */}
      <div className="text-center space-y-2">
        <div className="flex justify-center">
          <div className="p-4 rounded-2xl bg-blue-50 dark:bg-blue-900/20">
            <Smartphone className="h-12 w-12 text-blue-600" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-[var(--fc-foreground)]">App Mobile FieldCore</h1>
        <p className="text-[var(--fc-foreground-muted)]">
          Scarica l'app Android per gestire interventi, presenze e magazzino dal telefono.
        </p>
      </div>

      {/* QR Code + Download */}
      <div className="rounded-2xl border border-[var(--fc-border)] bg-[var(--fc-surface)] p-8 flex flex-col items-center gap-6">
        <div className="p-4 rounded-xl bg-white shadow-sm">
          <QRCode
            value={APK_URL}
            size={200}
            level="M"
          />
        </div>

        <p className="text-sm text-[var(--fc-foreground-muted)] text-center">
          Inquadra il QR con la fotocamera del telefono oppure scarica direttamente:
        </p>

        <a
          href={APK_URL}
          download="fieldcore.apk"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-semibold text-base transition-colors"
        >
          <Download className="h-5 w-5" />
          Scarica APK Android
        </a>
      </div>

      {/* Istruzioni installazione */}
      <div className="rounded-2xl border border-[var(--fc-border)] bg-[var(--fc-surface)] p-6 space-y-4">
        <h2 className="font-semibold text-[var(--fc-foreground)]">Come installare</h2>
        <ol className="space-y-3 text-sm text-[var(--fc-foreground-muted)]">
          <li className="flex gap-3">
            <span className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 font-bold text-xs flex items-center justify-center">1</span>
            <span>Scarica il file APK sul tuo dispositivo Android</span>
          </li>
          <li className="flex gap-3">
            <span className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 font-bold text-xs flex items-center justify-center">2</span>
            <span>Vai in <strong>Impostazioni → Sicurezza</strong> e abilita <em>"Origini sconosciute"</em> o <em>"Installa app sconosciute"</em></span>
          </li>
          <li className="flex gap-3">
            <span className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 font-bold text-xs flex items-center justify-center">3</span>
            <span>Apri il file APK scaricato e conferma l'installazione</span>
          </li>
          <li className="flex gap-3">
            <span className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 font-bold text-xs flex items-center justify-center">4</span>
            <span>Accedi con le stesse credenziali del portale web</span>
          </li>
        </ol>
      </div>

      {/* Note */}
      <div className="rounded-xl border border-amber-200 bg-amber-50 dark:bg-amber-900/10 dark:border-amber-800 p-4 flex gap-3">
        <Shield className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-amber-800 dark:text-amber-300 space-y-1">
          <p className="font-semibold">App distribuita internamente</p>
          <p>Questa app è distribuita solo per uso aziendale. Richiede connessione alla rete Kleis (VPN o rete interna) oppure accesso tramite HTTPS al dominio aziendale.</p>
        </div>
      </div>

      <div className="rounded-xl border border-blue-100 bg-blue-50 dark:bg-blue-900/10 dark:border-blue-800 p-4 flex gap-3">
        <Wifi className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-blue-800 dark:text-blue-300">
          <p>L'app funziona anche <strong>offline</strong>: ticket e rapportini vengono sincronizzati automaticamente al ripristino della connessione.</p>
        </div>
      </div>
    </div>
  )
}
